import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdminHome from './AdminHome';
import { IoCloseSharp } from "react-icons/io5";
import { BsMenuButtonWideFill } from "react-icons/bs";
const AdminAddStyle = () => {
  const [styleName, setstyleName] = useState('');
  const [styleId, setstyleId] = useState(null);
  const [message, setMessage] = useState('');

  // Fetch the next Style ID when the component mounts or after saving
  const fetchNextStyleId = async () => {
    try {
      const response = await axios.get('/api/next-style-id');
      setstyleId(response.data.styleId);
    } catch (error) {
      console.error('Error fetching next Style ID:', error);
    }
  };

  useEffect(() => {
    fetchNextStyleId();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Save the Style
      const response = await axios.post('/api/add-style', {
        styleName,
      });

      // Show success message
      setMessage('Style saved successfully!');

      // Clear the Style name input field
      setstyleName('');

      // Fetch the next Style ID immediately
      fetchNextStyleId();
    } catch (error) {
      setMessage('Failed to save Style');
      console.error(error);
    }
  };

  return (
<>
<div className="tf-page-title">
            <div className="container-full">
                <div className="heading text-center">Add New Style</div>
            </div>
        </div>
        <section className="flat-spacing-11">
            <div className="container">
                    <div className="row">
                      <AdminHome/>
    <div className="admin-style-form col-lg-9">
      {/* <h2>Style Form</h2> */}
      <div className="style-details">
        <p><strong>Style ID:</strong> {styleId}</p>
        <p><strong>Style Name:</strong></p>
        <input
          type="text"
          value={styleName}
          onChange={(e) => setstyleName(e.target.value)}
          placeholder="Enter style name"
          required
          className="style-input"
        />
      </div>
      <button onClick={handleSubmit} className="save-button">Save</button>
      {message && <p className="message">{message}</p>}

      <style jsx>{`
        .admin-style-form {
          font-family: Arial, sans-serif;
          max-width: 600px;
          margin: 20px auto;
          padding: 20px;
          background-color: #f9f9f9;
          border-radius: 8px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        
        h2 {
          text-align: center;
          margin-bottom: 20px;
          color: #333;
        }
        
        .style-details {
          margin-bottom: 20px;
        }
        
        .style-details p {
          font-size: 16px;
          margin-bottom: 8px;
          color: #555;
        }
        
        .style-input {
          width: 100%;
          padding: 10px;
          font-size: 16px;
          border: 1px solid #ccc;
          border-radius: 4px;
          margin-bottom: 20px;
          outline: none;
          transition: border-color 0.3s;
        }

        .style-input:focus {
          border-color: #007bff;
        }

        .save-button {
          width: 100%;
          padding: 12px;
          font-size: 16px;
          background-color: #28a745;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          transition: background-color 0.3s;
        }

        .save-button:hover {
          background-color: #218838;
        }

        .message {
          text-align: center;
          font-size: 16px;
          color: #333;
        }
      `}</style>
    </div>
    </div>
    </div>



            <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                <div className="canvas-wrapper">
                    <header className="canvas-header">
                        <span className="title">SIDEBAR ACCOUNT</span>
                     
                        <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                    </header>
                    <div className="canvas-body sidebar-mobile-append"> </div>
                </div>
            </div>
    </section>
    
    <div className="btn-sidebar-account">
                                      <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
                                          <BsMenuButtonWideFill />
                                      </button>
                                  </div>
                      
                                  <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
                                      <div className="canvas-wrapper">
                                          <header className="canvas-header">
                                              <span className="title">SIDEBAR ACCOUNT</span>
                                              {/* <SideNavbaBarDashboard /> */}
                                              <span data-bs-dismiss="offcanvas" aria-label="Close"><IoCloseSharp /></span>
                                          </header>
                                          
                                          <div className="canvas-body sidebar-mobile-append"> </div>
                                      </div>
                                  </div>
    </>
  );
};

export default AdminAddStyle;
